import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Button, Flex, Modal, Row, Space, Spin } from "antd";
import PatientInfo, {
  PatientInfoRef,
} from "./components/PatientInfo/PatientInfo";
import { StepInfo } from "components/common";

import { useAppDispatch, useAppSelector } from "redux/hooks";
import residentialNurseService from "api/residentialNurse";
import { setActiveKey, setIdPhieuKham } from "redux/reducer/common";
import { residentialNurse } from "types/enums/residential-nurse";
import Notification from "components/common/notification/notification";
import {
  Cancel,
  Completed,
  Pause,
  PrintCertificate,
  Save,
  SaveAndPrint,
} from "pages/Refractive/InforDetails/config";
import SurgeryDetail from "./components/SurgeryDetail/SurgeryDetail";
import PersonalInfo from "./components/PersonelInfo/PersonelInfo";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import "./Detail.scss";
import { PrintColorWhiteSVG, PrinterSVG } from "assets";
import PrintPhieuPT from "./components/PrintPhieuPT/PrintPhieuPT";
import SurgeryCertificate from "./components/SurgeryCertificate/SurgeryCertificate";

const DetailInfo = React.forwardRef((props: any, ref) => {
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const surgeryDetailRef = useRef<PatientInfoRef | null>(null);
  const patientInfoRef = useRef<PatientInfoRef | null>(null);
  const personalInfoRef = useRef<PatientInfoRef | null>(null);
  const [id, setId] = useState<number | string>(null);

  const [detailPatient, setDetailPatient] = useState(null);

  const modalRef = useRef<any>();
  const modalRefSurgeryCertificate = useRef<any>();

  // const detailInfo = useAppSelector((e) => e.residentialNurse.detailInfo);

  const dispatch = useAppDispatch();
  useImperativeHandle(ref, () => ({
    setId: (id) => setId(id),
    setOpenModal: setOpenModal,
  }));
  //thông tin bệnh nhân
  const getPatientInfo = async () => {
    setLoading(true);
    const res = await residentialNurseService.getPatientInfoById(id);
    return res;
  };

  //chi tiết quá trình phẫu thuật
  const getDetailInfoById = async () => {
    const res = await residentialNurseService.getDetailInfoById(id);

    return res;
  };

  const handlePrintCertificate = () => {
    modalRefSurgeryCertificate.current?.openModal();
  };

  useEffect(() => {
    if ((id || id != null || id != undefined) && openModal) {
      const fetchData = async () => {
        try {
          const [patientInfo, detailInfoById] = await Promise.all([
            getPatientInfo(),
            getDetailInfoById(),
          ]);

          setDetailPatient({ ...patientInfo, ...detailInfoById });
          setLoading(false);
        } catch (error) {
          setLoading(false);

          console.log("🚀 ~ fetchData ~ error:", error);
          Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
        }
      };

      fetchData();
    }
  }, [openModal]);

  const handleCancel = () => {
    setOpenModal(false);
  };

  return (
    <Modal
      open={openModal}
      onCancel={handleCancel}
      width={1500}
      title={"Phiếu phẫu thuật"}
      wrapClassName="modal-custom"
      footer={false}
    >
      <Spin spinning={loading}>
        <Row justify={"end"}>
          <Flex gap={8}>
            <Button
              type="primary"
              className="btn-sub"
              onClick={() => {
                modalRef.current.openModal();
              }}
              icon={<PrintColorWhiteSVG />}
            >
              In phiếu
            </Button>
            <Button
              type="primary"
              className="btn-sub"
              icon={<PrintColorWhiteSVG />}
              onClick={() => modalRefSurgeryCertificate.current.openModal()}
            >
              In giấy chứng nhận PT
            </Button>
          </Flex>
        </Row>
        <Row className="detail-info-surgery">
          <Space direction="vertical">
            <div className="container">
              <div className="title">Thông tin bênh nhân</div>
              <PatientInfo ref={patientInfoRef} dataSurgery={detailPatient} />
            </div>
            <div className="container">
              <StepInfo />
            </div>
            <div className="container">
              <div className="title">Nhân sự phẫu thuật</div>
              <PersonalInfo
                dataPersonalInfo={detailPatient}
                ref={personalInfoRef}
              />
            </div>

            <div className="container">
              <div className="title">Chi tiết quá trình phẫu thuật</div>
              <SurgeryDetail
                allSurgeryDetailInfo={detailPatient}
                infoPatient={detailPatient}
                ref={surgeryDetailRef}
              />
            </div>
          </Space>
        </Row>
        <ModalCustom ref={modalRef} width={1100} title="In phiếu phẫu thuật">
          <PrintPhieuPT surgeryDetail={detailPatient} id={id} />
        </ModalCustom>
        <ModalCustom ref={modalRefSurgeryCertificate} width={1100}>
          <SurgeryCertificate detailInfo={detailPatient} />
        </ModalCustom>
        <Row justify={"end"}>
          <Button danger onClick={handleCancel}>
            Huỷ
          </Button>
        </Row>
      </Spin>
    </Modal>
  );
});

export default DetailInfo;
